import React from "react"
import { useRouteLoaderData } from "react-router-dom"
import DatasetCard from "./DatasetCard"
import { Datasets } from "../lib/store"
import {
  Box,
  Flex,
  Heading,
  Link,
  ListItem,
  OrderedList,
  Text,
} from "@chakra-ui/react"

export default function DatasetsList() {
  const user = useRouteLoaderData("auth")
  const [datasets] = Datasets.useState()

  if (!user) return null

  return (
    <Flex
      direction="column"
      gap="1em"
      flexWrap="wrap"
      justifyContent="flex-start"
      overflowY="auto"
      p="0em 2em 1em 2em"
    >
      <Box
        p="1em"
        bg="gray.50"
        borderRadius="md"
        borderWidth="1px"
        borderColor="gray.200"
        mb="1em"
      >
        <Text fontSize="sm" mb="0.5em">
          <strong>Limit numbers of records:</strong> 20,000
        </Text>
        <Text fontSize="sm">
          <strong>Maximum number of fields:</strong> 10
        </Text>
      </Box>
      <Flex gap="1em" flexWrap="wrap" justifyContent="flex-start">
        <DatasetCard dataset="default" />
        {Object.keys(datasets).length < 1 && (
          <Box>
            <Heading variant="standardSub">
              Welcome to the Blind Insight Beta!
            </Heading>
            <Text>
              Start exploring the UI or check out the links below for the full
              developer experience.
            </Text>
            <Heading variant="standardSub" mt="1.5em">
              Developer Quickstart
            </Heading>
            <OrderedList>
              <ListItem>
                <Link
                  href="https://docs.blindinsight.io/download/"
                  target="new"
                >
                  Download the Blind Proxy
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href="https://github.com/blind-insight/demo-datasets/releases"
                  target="new"
                >
                  Download a sample dataset, or use your own
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href="https://docs.blindinsight.io/getting-started/"
                  target="new"
                >
                  Check out the Getting Started Guide
                </Link>
              </ListItem>
            </OrderedList>
          </Box>
        )}
        {Object.values(datasets).map((dataset, index) => (
          <Box key={index}>
            <DatasetCard dataset={dataset} />
          </Box>
        ))}
      </Flex>
    </Flex>
  )
}
